import type { SentryInstance } from "@solvari/utils";

import { getSentry } from "@solvari/utils";

function getSentryAbTesting(): SentryInstance {
  return getSentry({ tags: { project: "mkt-ab-testing" } });
}

export { getSentryAbTesting };
